export default "__VITE_PUBLIC_ASSET__ba8d1b6b__"